<template>
    <div
        class="custom-control custom-checkbox"
        :class="[
            {disabled: disabled},
            {[`custom-checkbox-${type}`]: type},inlineClass]">
        <input
            :id="cbId"
            v-bind="$attrs"
            v-model="model"
            class="custom-control-input"
            :aria-label="ariaLabel"
            :class="inputClasses"
            type="checkbox"
            :disabled="disabled">
        <label
            :for="cbId"
            class="custom-control-label"
            :class="{'multi-line': multiLine}">
            <slot>
                <span v-if="inline">&nbsp;</span>
            </slot>
        </label>
    </div>
</template>
<script>
export default {
    name: "BaseCheckbox",
    props: {
        modelValue: {
            type: [Array, Boolean, Number],
            description: "Whether checkbox is checked"
        },
        disabled: {
            type: Boolean,
            description: "Whether checkbox is disabled"
        },
        ariaLabel: String,
        inline: {
            type: Boolean,
            description: "Whether checkbox is inline"
        },
        inputClasses: {
            type: [String, Object, Array],
            description: "Checkbox input classes"
        },
        type: {
            type: String,
            description: 'Checkbox type (e.g info, danger etc)'
        },
        multiLine: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cbId: "",
            touched: false
        };
    },
    computed: {
        model: {
            get() {
                return Array.isArray(this.modelValue) ? this.modelValue : !!this.modelValue;
            },
            set(check) {
                if (!this.touched) {
                    this.touched = true;
                }
                this.$emit("update:modelValue", check);
            }
        },

        inlineClass() {
            if (this.inline) {
                return `form-check-inline`;
            }
            return ''
        }
    },
    mounted() {
        this.cbId = Math.random()
            .toString(16)
            .slice(2);
    }
};
</script>
<style scoped>
.multi-line {
    height: auto !important;
}
</style>
